module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/privacy-policy/privacy-policy.component.scss
// module id = ./src/app/privacy-policy/privacy-policy.component.scss
// module chunks = main